export enum Role {
    Master = 'ROLE_MASTER',
    Admin = 'ROLE_ADMIN',
    Operador = 'ROLE_OPER'
  }